import { Controller } from "@hotwired/stimulus";

// Auto-dismissing toast notification. Slides in from below, stays for
// `duration` ms, then fades out and removes itself from the DOM.
export default class extends Controller {
  static targets = ["message"];
  static values = { duration: { type: Number, default: 4000 } };

  connect() {
    // Slide in after a brief frame so the transition plays
    requestAnimationFrame(() => {
      this.messageTargets.forEach((el) => {
        el.classList.remove("translate-y-2", "opacity-0");
        el.classList.add("translate-y-0", "opacity-100");
      });
    });

    // Auto-dismiss
    this._timer = setTimeout(() => this.dismiss(), this.durationValue);
  }

  disconnect() {
    if (this._timer) clearTimeout(this._timer);
  }

  dismiss() {
    this.messageTargets.forEach((el) => {
      el.classList.remove("translate-y-0", "opacity-100");
      el.classList.add("translate-y-2", "opacity-0");
    });
    // Remove from DOM after the fade-out transition
    setTimeout(() => this.element.remove(), 300);
  }
}
